import { observable, action, flow } from "mobx";
import { getSites, checkPrimaryCaptcha, checkPrimaryGoogleCaptcha } from "services/api";

function isMenuCollapsed() {
    var collapsed = localStorage.getItem("rankerx-menu-collapsed");
    if (collapsed == null) {
        collapsed = true;
        setMenuCollapsed(collapsed);
    }
    return;
}

function setMenuCollapsed(collapsed) {
    localStorage.setItem("rankerx-menu-collapsed", collapsed);
}

export default class UIStore {
    @observable collapsed = isMenuCollapsed();
    @observable sites = []

	@action
	setCollapsed(collapsed) {
        this.collapsed = collapsed;
        setMenuCollapsed(collapsed);
    }
    
    constructor() {        
    }

    fetchSites = flow(function*(){
        const response = yield getSites();        
        if (response == null || response.error) {
            return;
        }        
        this.sites = observable.array(response);
    })

    checkImageCaptchaService = flow(function*(){
        const response = yield checkPrimaryCaptcha();        
        return response
    })

    checkGoogleCaptchaService = flow(function*(){
        const response = yield checkPrimaryGoogleCaptcha();
        return response;
    })
}
